import "./firstsection.css";
import me from "../../images/profile_img.jpeg";
import NET from "vanta/dist/vanta.net.min";
import { useEffect, useRef, useState } from "react";
function FirstSection() {
  const netRef = useRef();
  const [vantaEffect, setVantaEffect] = useState(0);
  useEffect(() => {
    if (!vantaEffect) {
      setVantaEffect(
        NET({
          el: netRef.current,
          mouseControls: true,
          touchControls: true,
          gyroControls: false,
          minHeight: 200.0,
          minWidth: 200.0,
          scale: 1.0,
          scaleMobile: 1.0,
          color: 0x00ba94,
          backgroundColor: 0x151e3c,
        })
      );
    }
    return () => {
      if (vantaEffect) vantaEffect.destroy();
    };
  }, [vantaEffect]);
  return (
    <section ref={netRef} className="section" id="home">
      <div className="outer">
        <div className="wrapper">
          <div className="content">
            <div className="about">
              <h2>Hi, my name is Kyle.</h2>
              <h2>I am a full-stack software engineer.</h2>
            </div>
            <div>
              <img className="profile-img" src={me} alt="me"></img>
            </div>
          </div>
        </div>
        <div className="bott" id="about"></div>
      </div>
    </section>
  );
}

export default FirstSection;
